import { useMutation, useQueryClient } from '@tanstack/react-query';

import { companyCrmRoutingQuery } from '@/entities/company';
import {
  updateCompanyCrmRouting,
  UpdateCompanyCrmRoutingRequestDto,
} from '@/shared/api/companies';
import { useAppQuery } from '@/shared/lib/useAppQuery';

export function useCompanyCrmRouting(companyId: string | undefined) {
  return useAppQuery({
    ...companyCrmRoutingQuery(companyId!),
    enabled: Boolean(companyId),
    customError: true,
  });
}

export function useUpdateCompanyCrmRouting(companyId: string) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (data: UpdateCompanyCrmRoutingRequestDto) =>
      updateCompanyCrmRouting(companyId, data),
    onSuccess: () =>
      queryClient.invalidateQueries({
        queryKey: companyCrmRoutingQuery(companyId).queryKey,
      }),
  });
}
